import { render, staticRenderFns } from "./Customizacion.vue?vue&type=template&id=f8b05f30&scoped=true"
import script from "./Customizacion.vue?vue&type=script&lang=js"
export * from "./Customizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b05f30",
  null
  
)

export default component.exports